<template lang="pug">
bottom-modal(:id="modalId" width="w-xtra-large")
    span(slot="header-text") Add Products

    template
        div(slot="body")
            .container
                .row
                    .col-md-3
                        filter-sidebar(
                            :updateFilters="updateFilters"
                            :onAddAllChange="setAddAllMatch"
                            :enableAddAllMatching="false"
                        )

                    .col-md-9
                        .alert.alert-info
                            template(v-if="tax.products.length > 1")
                                | {{ tax.products.length }} products selected
                            template(v-else-if="tax.products.length === 1")
                                | {{ tax.products.length }} product selected
                            template(v-else)
                                | No product selected

                        v-server-table(
                            :url="productsUrl"
                            :columns="columns"
                            :options="tableOptions"
                            :name="tableName"
                            ref="datatable"
                        )
                            template(slot="select" slot-scope="props")
                                label.md-check
                                    input(
                                        :disabled="addAllMatching"
                                        type="checkbox"
                                        :checked="checkedExistingProducts(props.row)"
                                        @change="assignProducts(props.row)"
                                    )
                                    i.indigo
</template>

<script>
const TableName = 'VUETABLE_PRODUCTS';

import filterSidebar from '../pricebook/template/filter-sidebar';

export default {
    components: { filterSidebar },

    props: {
        taxId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            tax: {
                products: [],
            },
            modalId: 'modalProductTax',
            tableName: TableName,
            addAllMatching: false,
            columns: ['select', 'name', 'code'],
            filters: {
                category: null,
                tags: [],
                search: null,
            },
        };
    },

    computed: {
        productsUrl() {
            let url = Laroute.route('franchise.vue.products');

            if (this.taxId) {
                url += `?tax_id=${this.taxId}`;
            }

            return url;
        },

        tableOptions() {
            return {
                filterable: false,
                sortable: [],
                skin: 'table table-striped table-bordered m-b-0 b-b',
                params: {
                    category_id: this.filters.category,
                    query: this.filters.search,
                    tag_ids: this.filters.tags.map(t => t.id),
                },
            };
        },
    },

    methods: {
        showModal() {
            $(`#${this.modalId}`).modal('show');
        },

        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        registerTax(tax) {
            this.tax = tax;
        },

        assignProducts(row) {
            const index = this.tax.products.findIndex(p => p.id === row.id);

            if (index !== -1) {
                this.tax.products.splice(index, 1);
            } else {
                this.tax.products.push(row);
            }
        },

        checkedExistingProducts(row) {
            if (this.tax.products) {
                return this.tax.products.map(p => p.id).includes(row.id);
            }
        },

        refreshProducts() {
            this.$refs.datatable.refresh();
        },

        updateFilters(filters) {
            this.filters = filters;
            this.refreshFilters();
        },

        setAddAllMatch(addAll) {
            this.addAllMatching = addAll;
        },

        refreshFilters() {
            this.$nextTick(this.refreshProducts);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tax/add-products-form.vue